import Vue from "vue";
import Router from "vue-router";
import { isWeixinBrowser } from "@/utils/index";
import CONST from "@/utils/const";
import store from "@/store";
import { getOpenId } from "@/utils/auth";
import { getUserInfo } from "@/api/user";
import { getDictList } from "@/api/dict";
import { getClientList } from "@/api/client";
// import { getCurrentDate } from "@/api/commons";

import Home from "@/components/home";
import Service from "@/components/service";
import Mine from "@/components/mine";
import Layout from "@/components/layout";

import Address from "@/components/page/address";
import Company from "@/components/page/company";
import Recruit from "@/components/page/recruit";

import Files from "@/components/views/files";
import History from "@/components/views/history";
import Upload from "@/components/views/upload";
import Payment from "@/components/views/payment";
import ClientInfo from "@/components/views/client-info";
import BindUser from "@/components/bind-user";
import ServiceScore from "@/components/views/service-score";

import InvoiceList from "@/components/views/invoice/list";
import InvoiceEdit from "@/components/views/invoice/edit";

// 财务报告
import FinancialReportIndex from "@/components/views/financial-report/index.vue";
import FinancialReportLayout from "@/components/views/financial-report/layout.vue";
import BasicInfo from "@/components/views/financial-report/basic-info";
import TaxAnalyse from "@/components/views/financial-report/tax-analyse";
import CurrencyAnalyse from "@/components/views/financial-report/currency-analyse";
import StockAnalyse from "@/components/views/financial-report/stock-analyse";
import AssetsAnalyse from "@/components/views/financial-report/assets-analyse";
import PaymentAnalyse from "@/components/views/financial-report/payment-analyse";

import BalanceSheet from "@/components/views/financial-report/balance-sheet";
import IncomeStatement from "@/components/views/financial-report/income-statement";
import CashFlowStatement from "@/components/views/financial-report/cash-flow-statement";

import LuckPlay from '@/components/views/luck-play/play'
import LuckRegist from '@/components/views/luck-play/regist'

import Error from "@/components/error";

Vue.use(Router);

// 财务报告
export let FinanceReportComponents =  [
  {
    path: "index",
    name: "financial-report-index",
    component: FinancialReportIndex
  },
  {
    path: "basic-info",
    name: "basic-info",
    component: BasicInfo,
    meta:{
      title:'基本信息',
      icon:'user-circle-o'
    }
  },
  {
    path: "tax-analyse",
    name: "tax-analyse",
    component: TaxAnalyse,
    meta:{
      title:'税金分析',
      icon:'description'
    }
  },
  {
    path: "currency-analyse",
    name: "currency-analyse",
    component: CurrencyAnalyse,
    meta:{
      title:'货币资金分析',
      icon:'good-job-o'
    }
  },
  {
    path: "stock-analyse",
    name: "stock-analyse",
    component: StockAnalyse,
    meta:{
      title:'存货分析',
      icon:'balance-pay'
    }
  },
  {
    path: "assets-analyse",
    name: "assets-analyse",
    component: AssetsAnalyse,
    meta:{
      title:'固定资产分析',
      icon:'cashier-o'
    }
  },
  {
    path: "payment-analyse",
    name: "payment-analyse",
    component: PaymentAnalyse,
    meta:{
      title:'往来款项分析',
      icon:'after-sale'
    }
  },
  {
    path: "balance-sheet",
    name: "balance-sheet",
    component: BalanceSheet,
    meta:{
      title:'资产负债表',
      icon:'balance-pay'
    }
  },
  {
    path: "income-statement",
    name: "income-statement",
    component: IncomeStatement,
    meta:{
      title:'利润表',
      icon:'paid'
    }
  },
  {
    path: "cash-flow-statement",
    name: "cash-flow-statement",
    component: CashFlowStatement,
    meta:{
      title:'现金流量表',
      icon:'cash-on-deliver'
    }
  }
]
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: Layout,
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "Home",
          component: Home
        },
        {
          path: "/mine",
          name: "Mine",
          component: Mine
        },
        {
          path: "/financial-report",
          redirect: "/financial-report/index",
          name: "financial-report",
          component: FinancialReportLayout,
          children: [
            {
              path: "index",
              name: "financial-report-index",
              component: FinancialReportIndex
            }
          ]
        }
      ]
    },
    {
      path: "/address",
      name: "Address",
      component: Address
    },
    {
      path: "/company",
      name: "Company",
      component: Company
    },
    {
      path: "/recruit",
      name: "Recruit",
      component: Recruit
    },
    {
      path: "/service",
      name: "Service",
      component: Service
    },

    // 票据上传
    {
      path: "/files",
      name: "Files",
      component: Files
    },
    // 历史上传
    {
      path: "/history",
      name: "History",
      component: History
    },
    {
      path: "/upload/:type",
      name: "Upload",
      component: Upload
    },
    {
      path: "/invoice/list",
      name: "InvoiceList",
      component: InvoiceList
    },
    {
      path: "/invoice/edit",
      name: "InvoiceEdit",
      component: InvoiceEdit
    },
    // 缴费信息
    {
      path: "/payment",
      name: "Payment",
      component: Payment
    },
    // 财务报告
    {
      path: "/financial-report",
      redirect: "/financial-report/index",
      name: "financial-report",
      component: FinancialReportLayout,
      children:FinanceReportComponents
    },
    {
      path: "/client-info",
      name: "ClientInfo",
      component: ClientInfo
    },
    {
      path: "/bind-user",
      name: "BindUser",
      component: BindUser
    },
    {
      path: "/service-score",
      name: "ServiceScore",
      component: ServiceScore
    },
    {
      path: "/luck-play",
      name: "LuckPlay",
      component: LuckPlay
    },
    {
      path: "/luck-regist",
      name: "LuckRegist",
      component: LuckRegist
    },
    {
      path: "/error",
      name: "Error",
      component: Error
    }
  ]
});

const whiteList = ['/luck-play', '/luck-regist']

const checkUser = async (openId, next) => {
  const currClient = store.getters.currClient;
  if (currClient) {
    next();
  } else {
    const clientResp = await getClientList({ open_id: openId });
    const clientList = clientResp.obj || [];
    if (clientList.length > 0) {
      // const currentResp = await getCurrentDate({
      //   open_id: openId,
      //   dept_id: 1
      // });
      //TODO getCurrentDate 响应obj可能为null的情况需要处理
      // await store.dispatch("app/setCurrentDate", currentResp.obj.curr_date);
      await store.dispatch("app/setClientList", clientList);
      await store.dispatch("app/setCurrentClient", clientList[0]);
      await getDictData()

      next();
    } else {
      await store.dispatch("app/error", { hasErr: true, errMsg: "" });
      next({ path: "/bind-user" });
    }
  }
};

router.beforeEach(async (to, from, next) => {
  // 过滤白名单中的请求地址
  if (whiteList.indexOf(to.path) !== -1) {
    next()
    return
  }
  const openId = getOpenId();
  if (openId) {
    if (to.path === "/bind-user") {
      next();
    } else {
      store.dispatch("app/error", { hasErr: false, errMsg: "" });
      await checkUser(openId, next);
    }
  } else {
    const msg = "参数错误，请您重新进入系统";
    if (to.path === "/error") {
      store.dispatch("app/error", { hasErr: true, errMsg: msg });
      next();
    } else {
      const code = to.query.code;
      if (code) {
        const loginInfo = await getUserInfo({ code: code });
        if (loginInfo.success) {
          const isProduction = process.env.NODE_ENV === 'production'
          let openId = ''
          if(isProduction) {
            openId = loginInfo.openid
          } else {
            openId = "oRWW6s_X84XfEzluvOn3KYYG_GVE"; // For Test
          }
        store.dispatch("app/setOpenId", openId);
        await checkUser(openId, next);
        } else {
          store.dispatch("app/error", {
            hasErr: true,
            errMsg: loginInfo.msg
          });
          next({ path: "/error" });
        }
      } else {
        store.dispatch("app/error", { hasErr: true, errMsg: msg });
        next({ path: "/error" });
      }
    }
  }
});
async function getDictData(){
  if(!Vue.prototype.$dict){
    const dictData = await getDictList({ page:1,rows:99999999,status:1});
    let dict = {}
    dictData.rows.forEach(item => {
      dict[item.id]= item
    });
    Vue.prototype.$dict = dict
  }

}
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js